import React from 'react';
import {
  Box,
  Flex,
  Stack,
  Container,
  Text,
  Heading,
  Link,
  Button,
} from '@chakra-ui/react';

const DEFAULT_HEIGHT = '60vh';
const MIN_HEIGHT = 600;

interface HeroWithBackgroundImageProps {
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  imageUrl: string;
  height?: string;
  backgroundColor?: string;
  ctaLink?: string;
  buttonText?: string;
  additionalContent?: React.ReactNode;
}

const HeroWithBackgroundImage = ({
  title,
  description,
  imageUrl,
  height = DEFAULT_HEIGHT,
  backgroundColor = 'rgba(255,255,255,.85)',
  ctaLink,
  buttonText,
  additionalContent,
}: HeroWithBackgroundImageProps) => (
  <Box
    as={Flex}
    w="100%"
    h={['100%', height]}
    minHeight={MIN_HEIGHT}
    textAlign="center"
    alignItems="center"
    backgroundImage={`url(${imageUrl})`}
    backgroundSize="cover"
    backgroundPosition="center center"
    position="relative"
    _before={{
      background: backgroundColor,
      content: "''",
      position: 'absolute',
      width: '100%',
      height: ['100%', height],
      minHeight: MIN_HEIGHT,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    }}
  >
    <Container maxW="8xl" zIndex="10">
      <Stack as={Box} textAlign="center" spacing={8} py={[24, 36]}>
        <Heading
          fontWeight={700}
          fontSize={['3xl', '4xl', '5xl', '6xl']}
          lineHeight={['150%', '120%']}
          zIndex="10"
        >
          {title}
        </Heading>
        {description && (
          <Text fontSize={['xl', '2xl', '3xl']} fontWeight="300" zIndex="10">
            {description}
          </Text>
        )}
        {ctaLink && (
          <Link href={ctaLink} color="white">
            <Button size="lg" minW="64">
              {buttonText}
            </Button>
          </Link>
        )}
        {additionalContent && additionalContent}
      </Stack>
    </Container>
  </Box>
);

HeroWithBackgroundImage.defaultProps = {
  height: DEFAULT_HEIGHT,
  backgroundColor: 'rgba(255,255,255,.85)',
  description: undefined,
  buttonText: undefined,
  ctaLink: undefined,
  additionalContent: undefined,
};

export default HeroWithBackgroundImage;
